import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiPostsSectionDTO,
  PostsSectionDTO,
} from "@lib/strapi/dtos/components/sections/postsSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class PostsSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiPostsSectionDTO,
  ): Promise<PostsSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new PostsSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.layout = strapiData.layout;
    dto.maxItems = strapiData.maxItems;
    dto.showCategories = strapiData.showCategories;
    return dto;
  }
}
